const t = {
  name: "PowerButton",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,10v7h-2v-7H21z"/>
		<path class="st0" d="M16.5,13.9C14.4,15.1,13,17.4,13,20c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7c0-2.6-1.4-4.9-3.5-6.1l1-1.7
			c2.7,1.5,4.6,4.5,4.6,7.8c0,5-4,9-9,9c-5,0-9-4-9-9c0-3.4,1.8-6.3,4.6-7.8L16.5,13.9z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M2,20c0-9.9,8.1-18,18-18
			c9.9,0,18,8.1,18,18c0,9.9-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as PowerButton
};
